import L from 'leaflet';

const createIcon = (category, visibility) => {
  const categoryMap = {
    ruin: 'ruins',
    castle: 'castle',
    church: 'church',
    house: 'house',
    building: 'building'
  };

  const isPublic = visibility === 'public';
  const iconUrl = `/icons/${categoryMap[category]}.svg`;

  return L.divIcon({
    className: 'custom-icon',
    html: `
      <div class="marker-icon ${isPublic ? 'public' : 'private'}" style="--icon-mask: url(${iconUrl})">
        <img src="${iconUrl}" alt="${category}" />
      </div>
    `,
    iconSize: [32, 32], // Reduced from [41, 41]
    iconAnchor: [16, 32], // Adjusted from [20, 41]
    popupAnchor: [1, -34] // Adjusted from [1, -45]
  });
};

const categoryIcons = {
  castle: createIcon('castle', 'private'),
  castleP: createIcon('castle', 'public'),
  church: createIcon('church', 'private'),
  churchP: createIcon('church', 'public'),
  house: createIcon('house', 'private'),
  houseP: createIcon('house', 'public'),
  building: createIcon('building', 'private'),
  buildingP: createIcon('building', 'public'),
  ruin: createIcon('ruin', 'private'),
  ruinP: createIcon('ruin', 'public')
};

export default categoryIcons;